[
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "e1fe4f82-11f2-48ed-83d6-f14f85db0b29",
    "moduleAssignmentName": "Rukagen Visual Aid Certification",
    "startDate": "Today - 3 days",
    "endDate": "Today + 2 days",
    "assignedUsersCount": 0,
    "outOfAttemptsUsersCount": 3,
    "certifiedUsersCount": 41,
    "inProgressUsersCount": 10,
    "scoreCriteria": 0.8,
    "category": "ALL_ASSIGNMENTS",
    "teamUuids": [
      "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
      "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "7d820963-abd8-4452-9490-9ad856f69723",
    "moduleAssignmentName": "Rukagen Value Proposition Certification",
    "startDate": "Today - 3 days",
    "endDate": "Today + 2 days",
    "assignedUsersCount": 0,
    "outOfAttemptsUsersCount": 0,
    "certifiedUsersCount": 53,
    "inProgressUsersCount": 1,
    "scoreCriteria": 0.8,
    "category": "ALL_ASSIGNMENTS",
    "teamUuids": [
      "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
      "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "e1fe4f82-11f2-48ed-83d6-f14f85db0b29",
    "moduleAssignmentName": "Rukagen Visual Aid Certification",
    "startDate": "Today - 3 days",
    "endDate": "Today + 2 days",
    "assignedUsersCount": 0,
    "outOfAttemptsUsersCount": 3,
    "certifiedUsersCount": 41,
    "inProgressUsersCount": 10,
    "scoreCriteria": 0.8,
    "category": "RECENT_ASSIGNMENTS",
    "teamUuids": [
      "7e8f9a0b-1c3d-4e9f-93f6-4c8f9d0e1b5c",
      "9f0a1b2c-3d4e-5f6a-94e7-5d9e0f1a2b6d"
    ]
  },
  {
    "accountUuid": "79e17b87-9540-4a92-9f1c-5612e65261d2",
    "moduleAssignmentUuid": "7d820963-abd8-4452-9490-9ad856f69723",
    "moduleAssignmentName": "Rukagen Value Proposition Certification",
    "startDate": "Today - 3 days",
    "endDate": "Today + 2 days",
    "assignedUsersCount": 0,
    "outOfAttemptsUsersCount": 0,
    "certifiedUsersCount": 53,
    "inProgressUsersCount": 1,
    "scoreCriteria": 0.8,
    "category": "RECENT_ASSIGNMENTS",
    "teamUuids": [
      "0a1b2c3d-4e5f-6a7b-95c8-6e0f1a2b3c7e",
      "1b2c3d4e-5f6a-7b8c-96d9-7f1a2b3c4d8f"
    ]
  }
]
